<template>
  <div class="header-buttons">
    <ButtonComponent @click="editCard(0)" mod="gradient-bg">Создать</ButtonComponent>
    <ExportButtons
      :loading="exportInProgress"
      @exportExcel="exportExcel"
      @exportWord="exportWord"
      :exportTypes="['word', 'excel']"
    />
  </div>
</template>

<script>
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import ExportButtons from '@/common/components/redesigned/ExportButtons.vue';

  export default {
    name: 'HeaderButtons',
    emits: ['editCard', 'exportExcel', 'exportWord'],
    components: {
      ButtonComponent,
      ExportButtons,
    },
    props: {
      exportInProgress: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      editCard(id) {
        this.$emit('editCard', id);
      },
      exportExcel() {
        this.$emit('exportExcel');
      },
      exportWord() {
        this.$emit('exportWord');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .header-buttons {
    position: relative;
    display: flex;
    width: max-content;
    gap: 16px;
  }
</style>
